import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {TimelineLite} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import * as gsap from "gsap";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {WinterHoardGameModuleConfig} from "../WinterHoardGameModuleConfig";


export class PostWin implements GameRoundPresentation {
    private _gameData: ParsedGameData;
    private _tl: TimelineLite;

    constructor() {
    }

    getAnimation(data: ParsedServerData): gsap.Timeline | null {

        // TODO: FLAG
        if(this._gameData.singleWin <= 0) {
            return null;
        }

        if(!this._gameData.isBigWin){
            return null;
        }

        this._tl = new TimelineLite({paused:false});

        this._tl.add( // TODO: FLAG
            () => {this.getBetlineAnimations();}
        );

        return this._tl;
    }

    public prepare(data:ParsedServerData):void {
        this._gameData = <ParsedGameData> data;
    }

    public getBetlineAnimations():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        (<IBetLineWinData[]>this._gameData.betWins).forEach((betwin:IBetLineWinData, i:number)=>{
            tl.add(WinterHoardGameModuleConfig.animatedWinLines.playAnimatedWinline(betwin.betLineIndex, betwin.amount.toString()), 0)
        });
        return tl;
    }

}